export default "__VITE_ASSET__Up7d8YtU__"